(function ($) {
	"use strict";

	/*******Hamburgers Menu*******/
	$('.hamburger ').on('click', function() {
		$(".exo-menu").fadeToggle(200);   
		// Add this:
		$(".hamburger").toggleClass("is-active");
		$("body").toggleClass("overflow-hidden");
		$("#header").toggleClass('fixed-header'); 
		$("body").toggleClass("header-hovered");
		open = false;
	});

	$(".newsletter-submit").click(function(event) {

		// Fetch form to apply custom Bootstrap validation
		var form = $("#ContactFooter2")
	
		if (form[0].checkValidity() === false) {
		  event.preventDefault()
		  event.stopPropagation()
		}
		
		form.addClass('was-validated');
		// Perform ajax submit here...
		
	});

	if ($(window).width() < 769){
		$(".exo-menu .form-control").attr("placeholder", $.parseHTML("&#61442; Rechercher")[0].data);
	}
	
	/*******Sticky Header*******/
	$.fn.simpleStickyHeader = function(options) {
        var that = this;
        var headerOffsetTop = that.offset().top;

        var settings = $.extend({
            class: "sticky-header"
        }, options);

        var toggleFixedClass = (function toggleFixed() {
            that.toggleClass(settings.class, $(window).scrollTop() >= headerOffsetTop);
            return toggleFixed;
        })();

        $(window).scroll(toggleFixedClass);

        return this;
    };
	if (!$(".hamburger").hasClass("is-active")) {
		$("#sticky-header").simpleStickyHeader()
	} 

	/***************Mega Menu***************/ 
	if ($(window).width() < 991){
		$(".mega-drop-down .niveau01").click(function() {
			$(this).toggleClass('showing'); 
			$(this).next().slideToggle(100); 
			return false;
		});
	}

	/***************Bloc Recherche***************/ 
	$("#toggle-bloc-search").click(function() { 
		$("#menu-header .search").fadeIn(100); 
		if (!$('body').hasClass('header-hovered')) {
			$("body").addClass("header-hovered");
		}
		$('.search .form-control').focus();
	});
	
	$("#close-search").click(function(){
		$("#menu-header .search").fadeOut(100); 
		$("body").removeClass("header-hovered");
		return false;
	})


	/***************Script hovered Header***************/ 
	if ($(window).width() > 992){

		if (!$('body').hasClass('header-hovered')) {
			$(".mega-menu-link").mouseover(function() {
				$(".search").hide();   
				$("body").addClass("header-hovered");
			}).mouseout(function() {
				$("body").removeClass("header-hovered");
			});
		}
 
	
		$('#header .dropdown').on('show.bs.dropdown', function(){
			$("body").addClass("header-hovered");
		}); 
		$('#header .dropdown').on('hidden.bs.dropdown', function(){
			if ($('.exo-menu .search').is(':hidden')) {
				$("body").removeClass("header-hovered");
			}
		});
	}

	/***********Homepage*********/ 
	$('#slider').slick({
		dots: true,
		arrows:true, 
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		autoplay: true,
		adaptiveHeight: true,
		responsive: [
			{
			  breakpoint: 768,
			  settings: {
				arrows: false,
			  } 
			}
		  ]
	});

	if ($(window).width() < 768){
		var HeightImg = $('#slider .sliderhome-item img').height();
		$('.slick-dots').css("top", HeightImg + 'px')
	}
	
 
	/******* Push Produit ********/
	var $status = $('.pagingInfo');
	var $slickElement = $('.sliderPush');
	
	$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		var i = (currentSlide ? currentSlide : 0) + 1;
		$status.text(i + '/' + slick.slideCount);
	});
	
	

	var num = $('.sliderPush .product').length;
		if (num > 3){
			$slickElement.slick({
				centerMode: true,
				prevArrow: $('.prev'),
				nextArrow: $('.next'),
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [
					{
					  breakpoint: 768,
					  settings: {
						slidesToShow: 1,
						centerPadding: '0'
					  }
					} 
				  ]
			}).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				if (currentSlide !== nextSlide) {
					document.querySelectorAll('.slick-center + .slick-cloned').forEach((next) => {
						// timeout required or Slick will overwrite the classes
						setTimeout(() => next.classList.add('slick-current', 'slick-center'));
					});
				}
			}); 
			
		}else {
			$(".section-push-products").addClass("low");
			if ($(window).width() < 768){ 
				$slickElement.slick({
					centerMode: true,
					prevArrow: $('.prev'),
					nextArrow: $('.next'),
					slidesToShow: 3,
					slidesToScroll: 1,
					responsive: [
						{
						  breakpoint: 640,
						  settings: {
							slidesToShow: 1,
							centerPadding: '0'
						  }
						} 
					  ]
				}).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
					if (currentSlide !== nextSlide) {
						document.querySelectorAll('.slick-center + .slick-cloned').forEach((next) => {
							// timeout required or Slick will overwrite the classes
							setTimeout(() => next.classList.add('slick-current', 'slick-center'));
						});
					}
				});	 
			}
		}

	/******* Texte défilant Homepage********/
	$('.marquee').marquee({
		//duration in milliseconds of the marquee
		duration: 15000,
		//gap in pixels between the tickers
		gap: 0,
		//time in milliseconds before the marquee will start animating
		delayBeforeStart: 0,
		//'left' or 'right'
		direction: 'left',
		//true or false - should the marquee be duplicated to show an effect of continues flow
		duplicated: true
	});
	

	/********Page catalogue*********/ 

	if ($('.img-product').length) {
		setTimeout(function () {
			var HeightImgProduit = $('.img-product img').height();
			$('.video-product').css("min-height", HeightImgProduit + 'px')
		}, 500);  
	}  

	/********Page Produit*********/ 
	
	if ($('.MagicToolboxContainer').length) {
		setTimeout(function () {
			var HeightImgProduit = $('.MagicToolboxSlides').height();
			$('.magic-video-container').css("height", HeightImgProduit + 'px')
        }, 500); 
	} 

	$("#close-search").click(function(){
		$("#menu-header .search").fadeOut(100); 
		$("body").removeClass("header-hovered");
		return false;
	}) 

	/********Meni panier droite*********/ 
	$('.show-mini-cart .link').click(function(){
		$('#myMenu').addClass('active');
		$('body').addClass('myMenuOpened');
	});
	
	$(".close-mini-cart").click(function(){
		$('#myMenu').removeClass('active');
		$('body').removeClass('myMenuOpened');
	})
    

	/********Page Mone compte******/
	var newURL = window.location.href
	const word = 'recover';
	
	if (newURL.includes(word)) {
	   $(".login").addClass("d-none")
 	   $(".recover").removeClass("d-none")
	   $(".recover").removeAttr( 'style' )
	} 

	$("#RecoverPassword").click(function(){ 
		$(".login").addClass("d-none")
		$(".recover").removeClass("d-none")
		$(".recover").removeAttr( 'style' )

	})
	$("#HideRecoverPasswordLink").click(function(){ 
		$(".login").removeClass("d-none")
		$(".recover").addClass("d-none")
	})

 
	/********SlimSelect******/
	if ($('.select-sizes-color').length) {
		new SlimSelect({
			select: '#sizes-select'
		})
		new SlimSelect({
			select: '#color-select'
		})
	}  

	/********ScrollOnClickNewsLetter******/
	var $slider = $(".form-newsletter .input-error-message,.form-newsletter .message-form");

	if ($slider.length){
		$('html, body').animate({
			scrollTop: $(".newsletter-section").offset().top - 80
		}, 1000);
	}

})(jQuery);